export default __webpack_public_path__ + "static/media/market_place.84571db6.png";